<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M15.3594 5.375H12.9688V2.98438C12.9688 2.7233 12.865 2.47292 12.6804 2.28832C12.4958 2.10371 12.2454 2 11.9844 2H2.98438C2.7233 2 2.47292 2.10371 2.28832 2.28832C2.10371 2.47292 2 2.7233 2 2.98438V11.9844C2.00009 12.064 2.02272 12.142 2.06528 12.2093C2.10783 12.2766 2.16857 12.3305 2.24047 12.3648C2.29698 12.3922 2.35903 12.4064 2.42188 12.4063C2.51833 12.4063 2.61188 12.3733 2.68695 12.3127L5.35461 10.1563H5.375V12.5469C5.375 12.8079 5.47871 13.0583 5.66332 13.2429C5.84792 13.4275 6.0983 13.5313 6.35938 13.5313H12.9891L15.6568 15.6877C15.7319 15.7483 15.8254 15.7813 15.9219 15.7813C15.9847 15.7814 16.0468 15.7672 16.1033 15.7398C16.1752 15.7055 16.2359 15.6516 16.2785 15.5843C16.321 15.517 16.3437 15.439 16.3438 15.3594V6.35938C16.3438 6.0983 16.24 5.84792 16.0554 5.66332C15.8708 5.47871 15.6204 5.375 15.3594 5.375ZM5.20484 9.3125C5.10839 9.31245 5.01484 9.34546 4.93977 9.40602L2.84375 11.1005V2.98438C2.84375 2.94708 2.85857 2.91131 2.88494 2.88494C2.91131 2.85857 2.94708 2.84375 2.98438 2.84375H11.9844C12.0217 2.84375 12.0574 2.85857 12.0838 2.88494C12.1102 2.91131 12.125 2.94708 12.125 2.98438V9.17188C12.125 9.20917 12.1102 9.24494 12.0838 9.27131C12.0574 9.29769 12.0217 9.3125 11.9844 9.3125H5.20484ZM15.5 14.4755L13.404 12.781C13.3289 12.7205 13.2354 12.6875 13.1389 12.6875H6.35938C6.32208 12.6875 6.28631 12.6727 6.25994 12.6463C6.23357 12.6199 6.21875 12.5842 6.21875 12.5469V10.1563H11.9844C12.2454 10.1563 12.4958 10.0525 12.6804 9.86793C12.865 9.68333 12.9688 9.43295 12.9688 9.17188V6.21875H15.3594C15.3967 6.21875 15.4324 6.23357 15.4588 6.25994C15.4852 6.28631 15.5 6.32208 15.5 6.35938V14.4755Z"
      fill="#D7DCE6"
    />
    <path
      d="M5.20484 9.3125C5.10839 9.31245 5.01484 9.34546 4.93977 9.40602L2.84375 11.1005V2.98438C2.84375 2.94708 2.85857 2.91131 2.88494 2.88494C2.91131 2.85857 2.94708 2.84375 2.98438 2.84375H11.9844C12.0217 2.84375 12.0574 2.85857 12.0838 2.88494C12.1102 2.91131 12.125 2.94708 12.125 2.98438V9.17188C12.125 9.20917 12.1102 9.24494 12.0838 9.27131C12.0574 9.29769 12.0217 9.3125 11.9844 9.3125H5.20484Z"
      fill="#D7DCE6"
    />
  </svg>
</template>

<script>
export default {
  name: 'MessagesIconFilled18'
};
</script>

<style scoped>

</style>